import { defineField, defineType } from 'sanity'

export default defineType({
  title: 'Accessories Banners',
  name: 'accessoriesBanners',
  type: 'document',
  groups: [
    {
      name: 'configurator',
      title: 'Configurator',
      default: true,
    },
    {
      name: 'checkout',
      title: 'Checkout',
    },
  ],
  fields: [
    defineField({
      title: 'Desktop image',
      name: 'configuratorImgDesktop',
      type: 'image',
      options: {
        hotspot: true,
      },
      group: 'configurator',
    }),
    defineField({
      title: 'Mobile image',
      name: 'configuratorImgMobile',
      type: 'image',
      options: {
        hotspot: true,
      },
      group: 'configurator',
    }),
    defineField({
      title: 'Title',
      name: 'checkoutTitle',
      type: 'string',
      group: 'checkout',
    }),
    defineField({
      title: 'Button text',
      name: 'checkoutButtonText',
      type: 'string',
      group: 'checkout',
    }),
    defineField({
      title: 'Image',
      name: 'checkoutImg',
      type: 'image',
      options: {
        hotspot: true,
      },
      group: 'checkout',
    }),
    defineField({
      title: 'Link',
      name: 'link',
      type: 'string',
      group: ['configurator', 'checkout'],
    }),
  ],
})